import { inject, NgZone } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import {catchError, delay, throwError} from 'rxjs';
import {TokenService} from "../services/token/token.service";
import {LoaderService} from "../services/loader/loader.service";
import { Capacitor } from '@capacitor/core';


export const AuthInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);
  const tokenService = inject(TokenService);
  const ngZone = inject(NgZone);
  const loader = inject(LoaderService);
  const platform = Capacitor.getPlatform();

  const withPlatform = req.clone({
    setHeaders: { 'X-Platform': platform }
  });

  return next(withPlatform).pipe(
    catchError((error) => {
      // console.log('error', error);
      // console.log('req', req);
      // console.log('error.status', error.status);
      // console.log('!req.url.includes(\'/login\')', !req.url.includes('/login'));
      // console.log('error.status === 401 && !req.url.includes(\'/login\')', error.status === 401 && !req.url.includes('/login'));
      if (error.status === 401 && !req.url.includes('/login')) {
        tokenService.clearAllExcept();
        loader.hide();
        ngZone.run(() => {
          if (router.url !== '/welcome') {
            setTimeout(() => {
              router.navigateByUrl('/welcome', { replaceUrl: true });
            }, 0);
          }
        });
      }
      return throwError(() => error);
    })
  );
};
